import { Grid } from '@mui/material';
import React, { useCallback, useEffect } from 'react';
import './MarketingEmail.scss';
import MarketingEmailTable from './MarketingEmailTable';
import { useDispatch, useSelector } from 'react-redux';
import { quickInputSelector } from '../QuickInput/reducers/QuickInputReducer';
import EmailEditorModal from '../EmailEditorModal/EmailEditorModal';
import EmailEditorModel from '../EmailEditorModal/models/EmailEditorModel';
import { EmailSignatureSelector } from '../EmailSignature/reducers/EmailSignatureReducer';
import MarketingEmailApi, { SaveMarketingEmailParam } from './api/MarketingEmailApi';
import { EmailEditorSelector, setShowEmailEditor } from '../EmailEditorModal/reducers/EmailEditorReducer';
import BaseResponse from '../../app/BaseResponse';
import MarketingEmailModel from './models/MarketingEmailModel';
import Utility from '../../app/utility';
import { setTriggerSearch } from './reducers/MarketingEmailSearchReducer';
import { showLoading } from '../LoadingView/reducers/LoadingViewReducer';
import EmailSignature from '../EmailSignature/EmailSignature';

interface MarketingEmailProp {
    system: string,
}

const MarketingEmail: React.FunctionComponent<MarketingEmailProp> = (props) => {
    const dispatch = useDispatch();
    const emailSignatureData = useSelector(EmailSignatureSelector);
    const emailEditorData = useSelector(EmailEditorSelector);

    useEffect(() => {
        document.title = "Marketing Email";
    }, []);

    const save = (emailModel: EmailEditorModel) => {
        try {
            validate(emailModel);

            dispatch(showLoading(true));

            MarketingEmailApi.Save({
                emailFrom: emailModel.emailFrom,
                body: emailModel.emailContent,
                emailTo: emailModel.emailTo,
                subject: emailModel.emailSubject,
                system: props.system,
            } as SaveMarketingEmailParam)
                .then((response: BaseResponse<MarketingEmailModel>) => {
                    if (response.success) {
                        Utility.Alert.Success("Emails are added to queue.");

                        dispatch(setTriggerSearch(new Date().getTime()));
                        dispatch(setShowEmailEditor(false));
                    } else {
                        dispatch(showLoading(false));
                        Utility.Alert.Error(response.message);
                    }
                })
                .catch((error) => {
                    dispatch(showLoading(false));
                    Utility.Alert.Error(error);
                });
        } catch (error) {
            Utility.Alert.Error(error);
        }
    }

    const validate = (emailModel: EmailEditorModel) => {
        if (emailModel.emailTo.trim().length === 0) {
            throw "Email to is required";
        }

        if (emailModel.emailSubject.trim().length === 0) {
            throw "Subject is required";
        }

        if (emailModel.emailContent.trim().length === 0) {
            throw "Body is required";
        }
    }

    return (
        <Grid container className="MarketingEmail">
            <Grid container className="datatable">
                <MarketingEmailTable system={props.system}>
                </MarketingEmailTable>
            </Grid>
            <EmailEditorModal
                signature={props.system === "AscentBulk"? emailSignatureData.defaultSignature.signature : emailSignatureData.defaultEvoSignature.signature}
                onEmailSending={(emailModel: EmailEditorModel) => {
                    save(emailModel);
                }}
                system={props.system}
            >
            </EmailEditorModal>
            <EmailSignature system={props.system}></EmailSignature>
        </Grid>
    )
};

export default MarketingEmail;